/**
 * Created by jonas on 2020-11-19.
 */
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {TimelineLite,Timeline} from "gsap";

export class BuffaloPickFakeSpin implements GameRoundPresentation {
    private _fakeStart:boolean;

    constructor(fakeStart:boolean) {
        this._fakeStart = fakeStart;
    }

    getAnimation(data:ParsedServerData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();

        if (this._fakeStart) {
            tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED));
            });
        } else {
            tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STOPPED));
            });
        }


        return tl;
    }


}